export default __webpack_public_path__ + "static/media/min_ah_paik.29db278b.png";